import React, { useState } from 'react';
import ArrowRight from '@material-ui/icons/ArrowRight';
import ArrowDown from '@material-ui/icons/ArrowDropDown';

import { getShippedQuantity } from 'pages/Order/helpers';

import { Table, PartNumber, ExpandableCell, TableRowDotted, TableRow } from './styledComponents';
import { ShipmentBlock } from './ShipmentBlock';
import { CollapsedRows } from './CollapsedRows';
import { ItemTrackingDetails } from './ItemTrackingDetails';

const PartRows = ({ lineData }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const index = parseInt(lineData.displayLineNumber);
  const isEvenRow = index % 2 === 0;
  const isExpandedLine =
    (lineData.bomLines && lineData.bomLines.length) ||
    lineData.warrantyLine ||
    lineData.unitData.length;

  return (
    <>
      <tbody>
        <TableRowDotted darkBackground={isEvenRow}>
          <td>
            {isExpandedLine ? (
              <ExpandableCell onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? <ArrowDown /> : <ArrowRight />}
                <span>{index}</span>
              </ExpandableCell>
            ) : (
              <div>{index}</div>
            )}
          </td>
          <td>
            <PartNumber>{lineData.partNumber}</PartNumber>
          </td>
          <td>
            <div style={{ textAlign: 'center' }}>
              {getShippedQuantity(lineData)} of {lineData.lineOrderedQty}
            </div>
          </td>
          <td style={{ textAlign: 'right', paddingRight: '2.42rem' }}>
            <div>{lineData.lineStatus}</div>
          </td>
        </TableRowDotted>
        <TableRow darkBackground={isEvenRow}>
          <td />
          <td colSpan="2">
            {lineData.partDescription}
            <ShipmentBlock lineData={lineData} topSpacing spacing="space-between" />
            <ItemTrackingDetails lineData={lineData} />
          </td>
          <td />
        </TableRow>
      </tbody>
      {isExpandedLine ? (
        <CollapsedRows show={isExpanded} lineData={lineData} isEvenRow={isEvenRow} index={index} />
      ) : null}
    </>
  );
};

const ItemDetailsTable = ({ linesData }) => {
  return (
    <Table>
      <thead>
        <tr>
          <th>
            <div>#</div>
          </th>
          <th>
            <div>Part Number</div>
          </th>
          <th style={{ textAlign: 'center' }}>
            <div>Shipped Qty</div>
          </th>
          <th>
            <div>Status</div>
          </th>
        </tr>
      </thead>
      {linesData.map((line) => (
        <PartRows lineData={line} key={line.lineNumber} />
      ))}
    </Table>
  );
};

export { ItemDetailsTable };
